import { render, staticRenderFns } from "./SidebarPanelHeader.vue?vue&type=template&id=1b09c987"
import script from "./SidebarPanelHeader.vue?vue&type=script&lang=js"
export * from "./SidebarPanelHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports